import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DobAuthForm } from './DobAuthForm';
import { Layout } from 'components/Layout';
import { PortalResourceType } from 'utils/constants';
import { isSignedIn } from 'library/auth';
import { useSelector } from 'react-redux';

interface ProtectedResourcePageProps {
  resourceType: PortalResourceType;
  children: React.ReactNode;
}

export const ProtectedResourcePage = ({ resourceType, children }: ProtectedResourcePageProps) => {

  const patient = useSelector((state: any) => state.Patient.patients.get("patient"))
  const [isLoggedIn, setLoggedIn] = useState(isSignedIn());
  const { encodedResourceId, id } = useParams<{ encodedResourceId?: string; id?: string }>();
  const resourceId = encodedResourceId ?? id;

  if (!isLoggedIn || !patient) // validating both token and patient
    return <DobAuthForm
      onAuthenticate={() => setLoggedIn(true)}
      encodedResourceId={resourceId}
      resourceType={resourceType}
    />


  return <Layout>{children}</Layout>;
};
